import type { QueryTransactionHistoryListModel } from '@/api/transaction-history/model/transactionHistory'
import type { Action } from 'vuex'
import type { State, ListSortInfo, ListPageInfo, ProductInfo } from '.'

import { actionTypes, ListTypeEnum, ListStatusEnum } from '.'
import { queryTransactionHistory } from '@/api/transaction-history/transactionHistory'

const actions: { [actionType: string]: Action<State, any> } = {
  // State をリセット
  [actionTypes.RESET_STATE]({ commit }): void {
    commit(actionTypes.RESET_STATE)
  },

  [actionTypes.SET_PRODUCT_INFO]({ commit }, info: ProductInfo): void {
    commit(actionTypes.SET_PRODUCT_INFO, info)
  },

  // 取引履歴一覧を取得
  async [actionTypes.QUERY_TRANSACTION_LIST]({ commit, state }): Promise<void> {
    if (state.requestLock) {
      return
    }

    commit(actionTypes.SET_REQUEST_LOCK_STATUS, true)

    const data: QueryTransactionHistoryListModel = await queryTransactionHistory({
      folder_id: state.productInfo.folderID,
      product_id: state.productInfo.productID,
      sender_recipient_flag: state.activeListType,
      transaction_display_category: state.activeListStatus,
      ...state.listSortInfo,
      ...state.listPageInfo,
    })

    commit(actionTypes.QUERY_TRANSACTION_LIST, data)
    commit(actionTypes.SET_REQUEST_LOCK_STATUS, false)
  },

  // 一覧情報を設置
  [actionTypes.SET_LIST_SORT_INFO]({ commit }, info: ListSortInfo): void {
    commit(actionTypes.SET_LIST_SORT_INFO, info)
  },

  [actionTypes.SET_CURRENT_SORT_COLUMN_ID]({ commit }, id: string): void {
    commit(actionTypes.SET_CURRENT_SORT_COLUMN_ID, id)
  },

  [actionTypes.SET_LIST_PAGE_INFO]({ commit }, info: ListPageInfo): void {
    commit(actionTypes.SET_LIST_PAGE_INFO, info)
  },

  // 一覧種別を設置
  [actionTypes.SET_ACTIVE_LIST_TYPE]({ commit }, type: ListTypeEnum): void {
    commit(actionTypes.QUERY_TRANSACTION_LIST, {})
    commit(actionTypes.SET_ACTIVE_LIST_TYPE, type)
  },

  // 一覧状態を設置
  [actionTypes.SET_ACTIVE_LIST_STATUS]({ commit }, status: ListStatusEnum): void {
    commit(actionTypes.QUERY_TRANSACTION_LIST, {})
    commit(actionTypes.SET_ACTIVE_LIST_STATUS, status)
  },
}

export default actions
